import actions from "./actions";

const {
  MINING_DASHBOARD_DATA_BEGIN,
  MINING_DASHBOARD_DATA_SUCCESS,
  MINING_DASHBOARD_DATA_ERR,

  MINING_DASHBOARD_CATEGORY_DETAILS_BEGIN,
  MINING_DASHBOARD_CATEGORY_DETAILS_SUCCESS,
  MINING_DASHBOARD_CATEGORY_DETAILS_ERR,

  MINING_AUDIO_DATA_BEGIN,
  MINING_AUDIO_DATA_SUCCESS,
  MINING_AUDIO_DATA_ERR,

  POST_MINING_AUDIO_DATA_BEGIN,
  POST_MINING_AUDIO_DATA_SUCCESS,
  POST_MINING_AUDIO_DATA_ERR,

  SUBMIT_MINING_AUDIO_DATA_BEGIN,
  SUBMIT_MINING_AUDIO_DATA_SUCCESS,
  SUBMIT_MINING_AUDIO_DATA_ERR,

  STORE_LIST_BEGIN,
  STORE_LIST_SUCCESS,
  STORE_LIST_ERR,

  MINING_CATEGORY_LIST_BEGIN,
  MINING_CATEGORY_LIST_SUCCESS,
  MINING_CATEGORY_LIST_ERR,

  MINING_LISTEN_HOURS_BEGIN,
  MINING_LISTEN_HOURS_SUCCESS,
  MINING_LISTEN_HOURS_ERR,
} = actions;

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const miningDashboardDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MINING_DASHBOARD_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case MINING_DASHBOARD_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case MINING_DASHBOARD_DATA_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export const miningDashboardCategoryDetailsReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MINING_DASHBOARD_CATEGORY_DETAILS_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case MINING_DASHBOARD_CATEGORY_DETAILS_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case MINING_DASHBOARD_CATEGORY_DETAILS_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export const miningAudioDataReducers = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MINING_AUDIO_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case MINING_AUDIO_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case MINING_AUDIO_DATA_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export const postMiningAudioDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case POST_MINING_AUDIO_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case POST_MINING_AUDIO_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case POST_MINING_AUDIO_DATA_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export const submitMiningAudioDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case SUBMIT_MINING_AUDIO_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case SUBMIT_MINING_AUDIO_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case SUBMIT_MINING_AUDIO_DATA_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export const storeListReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case STORE_LIST_BEGIN:
      return { ...initialState, loading: true };

    case STORE_LIST_SUCCESS:
      return { ...initialState, data, loading: false };

    case STORE_LIST_ERR:
      return { ...initialState, error: err, loading: false };

    default:
      return state;
  }
};

export const miningCategoryListReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MINING_CATEGORY_LIST_BEGIN:
      return { ...initialState, loading: true };

    case MINING_CATEGORY_LIST_SUCCESS:
      return { ...initialState, data, loading: false };

    case MINING_CATEGORY_LIST_ERR:
      return { ...initialState, error: err, loading: false };

    default:
      return state;
  }
};

export const miningListenHoursReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case MINING_LISTEN_HOURS_BEGIN:
      return { ...initialState, loading: true };

    case MINING_LISTEN_HOURS_SUCCESS:
      return { ...initialState, data, loading: false };

    case MINING_LISTEN_HOURS_ERR:
      return { ...initialState, error: err, loading: false };

    default:
      return state;
  }
};
